import { Card } from '@/modules/common/models/card/card.ts';
import DocumentMasterApi from '@/modules/document/api/document-master-api.ts';
import type { IconComponent } from '@/modules/common/types/icon.type';
import type { TableId } from '@/modules/common/enums/table-id.enum.ts';

export default class LinkCard extends Card {
  href: string;
  linkType: typeof DocumentMasterApi.DEFAULT_LINK_TYPE;
  isLinkTypeInitial: boolean;
  linkTypeTableId: TableId;

  constructor(
    response: Record<string, unknown>,
    idKey: string,
    titleKey: string,
    icon: IconComponent,
    path: string,
    tableId: TableId
  ) {
    super(response, idKey, titleKey, icon, 'Номер');

    this.href = `/${path}/${this.id}`;
    this.linkType = DocumentMasterApi.DEFAULT_LINK_TYPE;
    this.isLinkTypeInitial = true;
    this.linkTypeTableId = tableId;
  }

  static resetLinkType<T extends LinkCard>(link: T): T {
    return {
      ...link,
      linkType: DocumentMasterApi.DEFAULT_LINK_TYPE,
      isLinkTypeInitial: true,
    } as T;
  }
}
